module.exports = "https://i.geely.com//img/ai-bk.6a187e5a.png";